/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

import drukFontUrl from "../fonts/Druk-Medium.woff2";

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}>
      <link rel="preload" as="font" href={drukFontUrl} type="font/woff2" crossOrigin="anonymous" />
      <script type="text/javascript">
        console.log(atob(
        "IF9fX19fICAgICAgICAgXyAgIF8gICAgIF8gICAgICAgXwp8ICBfX198IF9fIF9fX3wgfF98IHwgICAo" +
        "XylfIF9fIHwgfCBfXwp8IHxfIHwgJ19fLyBfIFwgX198IHwgICB8IHwgJ18gXHwgfC8gLwp8ICBffHwg" +
        "fCB8ICBfXy8gfF98IHxfX198IHwgfCB8IHwgICA8CnxffCAgfF98ICBcX19ffFxfX3xfX19fX3xffF98" +
        "IHxffF98XF9cCgpGcmV0TGluayByZWNydXRlOiBodHRwOi8vd3d3LndlbGNvbWV0b3RoZWp1bmdsZS5j" +
        "by9jb21wYW5pZXMvZnJldGxpbmsvam9icwoK" ));
      </script>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
